import React, { useEffect, useState } from "react";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { customerInternationalNumberAdd, customerQuickAddV2 } from "../../services/SearchAPI/CustomerQucikAdd";
import { useNavigate } from "react-router-dom";
import SuccessModal from "../SuccessModal";
import { getStoreLocalData } from "../../utils/localStorage";
import { color } from "chart.js/helpers";

export default function AddNewCustomer({
  addNewCustomerModalVisible,
  setAddNewCustomerModalVisible,
  storeId,
  brandId,
  validMobileNumber,
  StoreAddress,
  manualInput,
  enabledAddInternationalCustomer,
}) {
  const navigate = useNavigate();
  const mobileNum = manualInput === false ? validMobileNumber : "";
  const [customerNameValue, setCustomerNameValue] = useState("");
  const [customerMobileValue, setCustomerMobileValue] = useState("");
  const [customerInternationalMobileValue, setCustomerInternationalMobileValue] = useState("");
  const [customerAddressValue, setCustomerAddressValue] = useState("");
  const [customerCityValue, setCustomerCityValue] = useState("");
  const [customerPinCodeValue, setCustomerPinCodeValue] = useState("");
  const [error, setError] = useState("");
  const [modalVisible, setModalVisible] = useState(false);
  const [modalStatus, setModalStatus] = useState(false);
  const [modalText, setModalText] = useState("");
  const [showMoreInfo, setShowMoreInfo] = useState(false);
  const [switchCustomerType, setSwitchCustomerType] = useState(false)

  const { storeLocalData } = getStoreLocalData();

  const countryCode = storeLocalData?.countryCode;

  useEffect(() => {
    setCustomerCityValue(StoreAddress?.city);
    setCustomerPinCodeValue(StoreAddress?.pin);
  }, [StoreAddress]);

  useEffect(() => {
    setCustomerMobileValue(mobileNum);
  }, [mobileNum]);

   
  // const handleCustomerMobile = (number) => {
  //   const copyNumber = number.replace(/^\+91\s*|\s+/g, "");
  //   setCustomerMobileValue(copyNumber);
  // };

  // const handleCustomerMobile = (number) => {
  //   let copyNumber = number;

  //   if (countryCode === "+91") {
  //     // Remove +91 and spaces
  //     copyNumber = number.replace(/^\+91\s*|\s+/g, "");
  //   }
  //   else if (countryCode === "+971") {
  //     // Remove +971 and spaces
  //     copyNumber = number.replace(/^\+971\s*|\s+/g, "");
  //   }

  //   setCustomerMobileValue(copyNumber);
  // };

  const handleCustomerMobile = (number) => {
    setError("")
    const escapedCode = countryCode.replace("+", "\\+");

    const copyNumber = number.replace(
      new RegExp(`^${escapedCode}\\s*|\\s+`, "g"),
      ""
    );

    setCustomerMobileValue(copyNumber);
  };

   const handleCustomerName = (name) => {
     const copyName = name.replace(/[^A-Za-z0-9\., ]/g, "");
     setCustomerNameValue(copyName);
   };

   const handleCustomerAddress = (address) => {
     const copyAddress = address.replace(/[^A-Za-z0-9\-,. ]/g, '');
     setCustomerAddressValue(copyAddress);
   };

  const handleCustomerInternationalMobile = (number) => {
  const cleanedNumber = number.trim();
  const validNumberRegex = /^[+0-9]*$/;

  if (validNumberRegex.test(cleanedNumber)) {
    setCustomerInternationalMobileValue(cleanedNumber);
  }
}

  const handleModalClose = () => {
    setAddNewCustomerModalVisible(false);
    setShowMoreInfo(false);
    setCustomerMobileValue("");
    setCustomerInternationalMobileValue('')
    setIsButtonPressed(false);
    setSwitchCustomerType(false)
  };

  const [isButtonPressed, setIsButtonPressed] = useState(false);

  // const onNextButtonPress = async () => {
  //   if (!isButtonPressed) {
  //     setIsButtonPressed(true);
  //   }

  //   if (
  //     /^[56789]\d{0,9}$/.test(customerMobileValue) ||
  //     customerMobileValue === ""
  //   ) {
  //     if (customerMobileValue.length === 10) {
  //       setError(""); // Clear error if the input is valid
  //       // Create a new object with the entered addNewCustomer
  //       const newData = {
  //         storeId: storeId,
  //         mobileNo: customerMobileValue,
  //         firstName: customerNameValue ? customerNameValue : "BUYER",
  //         address: {
  //           addressLine1: customerAddressValue
  //             ? customerAddressValue
  //             : "Line 1",
  //           addressLine2: "",
  //           city: customerCityValue,
  //           landmark: "",
  //           pin: customerPinCodeValue,
  //           state: "",
  //         },
  //       };
  //       try {
  //         const response = await customerQuickAddV2(storeId, newData);
  //         if (!response.data.error) {
  //           const Res = response.data;
  //           if (Res.status === true) {
  //             setModalVisible(true);
  //             setModalStatus("success");
  //             setModalText("Customer added Successfully");
  //             setTimeout(async () => {
  //               navigate("/CustomerInfo", {
  //                 state: {
  //                   storeCustomerId: Res.storeCustomerId,
  //                 },
  //               });
  //             }, 1000); // Replace with actual async operation duration
  //             setIsButtonPressed(false);
  //           } else {
  //             setModalVisible(true);
  //             setModalStatus("notSuccess");
  //             setModalText(Res.message);
  //             setIsButtonPressed(false);
  //           }
  //         }
  //       } catch (error) {
  //         console.error("Error:", error);
  //       }

  //       setCustomerMobileValue("");

  //       setAddNewCustomerModalVisible(false);
  //       setError(""); // Clear any previous error message
  //       // Clear the input field
  //     } else {
  //       setError("Please enter a 10-digit mobile number");
  //       setIsButtonPressed(false);
  //     }
  //   } else {
  //     setError("Please enter a correct 10-digit mobile number");
  //     setIsButtonPressed(false);
  //   }
  // };

  const onNextButtonPress = async () => {
    if (!isButtonPressed) {
      setIsButtonPressed(true);
    }

    // Validation based on country code
    let isValid = false;

    if (countryCode === "+91") {
      // India: starts with 5-9 and total 10 digits
      isValid = /^[5-9]\d{9}$/.test(customerMobileValue);
    } else if (countryCode === "+971") {
      // UAE: starts with 5 and total 9 digits
      isValid = /^5\d{8}$/.test(customerMobileValue);
    }

    if (customerMobileValue === "") {
      setError("Please enter mobile number");
      setIsButtonPressed(false);
      return;
    }

    if (isValid) {
      setError("");

      const newData = {
        storeId: storeId,
        mobileNo: countryCode + customerMobileValue, 
        firstName: customerNameValue ? customerNameValue : "BUYER",
        address: {
          addressLine1: customerAddressValue
            ? customerAddressValue
            : "Line 1",
          addressLine2: "",
          city: customerCityValue,
          landmark: "",
          pin: customerPinCodeValue,
          state: "",
        },
      };


      try {
        const response = await customerQuickAddV2(
          storeId,
          newData
        );

        if (!response.data.error) {
          const Res = response.data;

          if (Res.status === true) {
            setModalVisible(true);
            setModalStatus("success");
            setModalText("Customer added Successfully");

            setTimeout(async () => {
              navigate("/CustomerInfo", {
                state: {
                  storeCustomerId: Res.storeCustomerId,
                },
              });
            }, 1000);

            setIsButtonPressed(false);
          } else {
            setModalVisible(true);
            setModalStatus("notSuccess");
            setModalText(Res.message);
            setIsButtonPressed(false);
          }
        }
      } catch (error) {
        console.error("Error:", error);
        setIsButtonPressed(false);
      }

      setCustomerMobileValue("");
      setAddNewCustomerModalVisible(false);
      setError("");
    } else {
      if (countryCode === "+91") {
        setError(
          "Please enter a valid 10-digit mobile number"
        );
      } else if (countryCode === "+971") {
        setError(
          "Please enter a valid 9-digit mobile number"
        );
      }

      setIsButtonPressed(false);
    }
  };

  const onNextInternationalButtonPress = async () => {
    if (!isButtonPressed) {
      setIsButtonPressed(true);
    }

    if (
      customerInternationalMobileValue !== ""
    ) {
       
        setError(""); // Clear error if the input is valid
        // Create a new object with the entered addNewCustomer
        const newData = {
          storeId: storeId,
          mobile: customerInternationalMobileValue,
          brandId: brandId,
          createIfNotFound: true,
        };
        try {
          const response = await customerInternationalNumberAdd(storeId, newData);
          if (!response.data.error) {
            const Res = response.data;
            if (Res.brandCustomer.id !== "") {
              setModalVisible(true);
              setModalStatus("success");
              setModalText("Customer added Successfully");
              setTimeout(async () => {
                navigate("/CustomerInfo", {
                  state: {
                    storeCustomerId: Res.id,
                  },
                });
              }, 1000); // Replace with actual async operation duration
              setIsButtonPressed(false);
            } else {
              setModalVisible(true);
              setModalStatus("notSuccess");
              setModalText(Res.message);
              setIsButtonPressed(false);
            }
          }
        } catch (error) {
          console.error("Error:", error);
        }

        setCustomerMobileValue("");

        setAddNewCustomerModalVisible(false);
        setError(""); // Clear any previous error message
        // Clear the input field
       
    } else {
      setError("Please enter a correct 10-digit mobile number");
      setIsButtonPressed(false);
    }
  };

  const handleAddInternationalCustomer = () => {
    setSwitchCustomerType(!switchCustomerType)
  }

  return (
    <div className="flex justify-content-center">
      <Dialog
        modal
        visible={addNewCustomerModalVisible}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!addNewCustomerModalVisible) return;
          handleModalClose();
          setShowMoreInfo(false);
        }}
        content={({ hide }) => (
          <div
            className="flex flex-column gap-4 "
            style={{
              borderRadius: "12px",
              backgroundColor: "#fff",
            }}
          >
            <div
              className="flex border-round-xl  justify-content-between align-items-center gap-2 px-4 py-2"
              style={{
                backgroundImage:
                  "radial-gradient(circle at left top, #2B70D7, #1752AA)",
              }}
            >
              <i
                className="pi pi-user-plus"
                style={{ fontSize: "50px", color: "#fff" }}
              ></i>
              <p className=" text-4xl text-primary-50 font-semibold">
                Add New Customer
              </p>
              <Button
                label="x"
                onClick={(e) => hide(e)}
                text
                className=" text-2xl text-primary-50 border-1 border-white-alpha-30 hover:bg-white-alpha-10"
              ></Button>
            </div>
            {switchCustomerType ? (
              <div className="mx-4">
                <div className="flex flex-row">
                  <p className="text-lg font-semibold ml-2">
                    International Customer Mobile
                  </p>
                  <p
                    className="text-lg font-semibold ml-2"
                    style={{ color: "red" }}
                  >
                    *
                  </p>
                </div>
                <InputText
                  value={customerInternationalMobileValue}
                  onChange={(e) =>
                    handleCustomerInternationalMobile(e.target.value)
                  }
                  id="mobile"
                  label="Mobile"
                  placeholder="Enter International Mobile No."
                  className="w-full text-xl h-3rem border-round-xl shadow-2"
                  maxLength={15}
                ></InputText>
                <p
                  className=" text-lg font-medium capitalize ml-2 mt-2"
                  style={{ color: "blue" }}
                >
                  Please enter International number with country code
                  +9198xxxxxxxx
                </p>
              </div>
            ) : (
              <div className="mx-4">
                <div className="flex flex-row">
                  <p className="text-lg font-semibold ml-2">Customer Mobile</p>
                  <p
                    className="text-lg font-semibold ml-2"
                    style={{ color: "red" }}
                  >
                    *
                  </p>
                </div>
                <InputText
                  value={customerMobileValue}
                  onChange={(e) => handleCustomerMobile(e.target.value)}
                  id="mobile"
                  label="Mobile"
                    placeholder={countryCode === '+971' ? "Enter 9 Digit Mobile No." : "Enter 10 Digit Mobile No."}
                  className="w-full text-xl h-3rem border-round-xl shadow-2"
                  keyfilter="int"
                    maxLength={countryCode === '+971' ? 9 : 10}
                ></InputText>
                  <p className="text-md" style={{color: "red"}}>{error}</p>
              </div>
            )}
            {!switchCustomerType && (
              <div
                className="flex-1 shadow-2 mx-4"
                style={{
                  backgroundColor: "#F6FAFF",
                }}
              >
                <div
                  className={
                    "flex flex-1 justify-content-between mx-2 py-2 cursor-pointer"
                  }
                  onClick={() => setShowMoreInfo(!showMoreInfo)}
                >
                  <div className="flex justify-content-start align-items-center flex-1 ">
                    <p
                      className=" text-lg font-medium capitalize ml-2"
                      style={{ color: "blue" }}
                    >
                      Show More Info
                    </p>
                  </div>
                  <div>
                    {!showMoreInfo ? (
                      <i
                        className="pi pi-angle-down"
                        style={{
                          fontSize: "25px",
                          cursor: "pointer",
                          color: "blue",
                        }}
                      ></i>
                    ) : (
                      <i
                        className="pi pi-angle-up"
                        style={{
                          fontSize: "25px",
                          cursor: "pointer",
                          color: "#blue",
                        }}
                      ></i>
                    )}
                  </div>
                </div>
              </div>
            )}
            {showMoreInfo && !switchCustomerType && (
              <div>
                <div className="flex flex-row">
                  <div className="mx-4">
                    <p className="text-lg font-semibold ml-2">Customer Name</p>
                    <InputText
                      value={customerNameValue}
                      onChange={(e) => handleCustomerName(e.target.value)}
                      id="name"
                      label="Name"
                      placeholder="Enter Customer Name"
                      className="w-full text-xl h-3rem border-round-xl shadow-2"
                    ></InputText>
                  </div>

                  <div className="mx-4">
                    <p className="text-lg font-semibold ml-2">Address</p>
                    <InputText
                      value={customerAddressValue}
                      onChange={(e) =>
                        handleCustomerAddress(
                          e.target.value
                        )
                      }
                      id="address"
                      label="Address"
                      placeholder="Enter Address"
                      className="w-full text-xl h-3rem border-round-xl shadow-2"
                    ></InputText>
                  </div>
                </div>
                <div className="flex flex-row">
                  <div className="mx-4">
                    <p className="text-lg font-semibold ml-2">City</p>
                    <InputText
                      value={customerCityValue}
                      onChange={(e) => setCustomerCityValue(e.target.value)}
                      id="city"
                      label="City"
                      placeholder="Enter City"
                      className="w-full text-xl h-3rem border-round-xl shadow-2"
                    ></InputText>
                  </div>
                  <div className="mx-4">
                    <p className="text-lg font-semibold ml-2">Pin Code</p>
                    <InputText
                      value={customerPinCodeValue}
                      onChange={(e) => setCustomerPinCodeValue(e.target.value)}
                      id="pincode"
                      label="PinCode"
                      placeholder="Enter Pin Code"
                      keyfilter="int"
                      maxLength={6}
                      className="w-full text-xl h-3rem border-round-xl shadow-2"
                    ></InputText>
                  </div>
                </div>
              </div>
            )}

            <Button
              onClick={
                switchCustomerType
                  ? onNextInternationalButtonPress
                  : onNextButtonPress
              }
              disabled={isButtonPressed}
              className="mt-1 mb-3 mx-4 border-round-xl "
            >
              <p className=" w-full text-2xl font-semibold flex justify-content-center">
                Add
              </p>
            </Button>
            {enabledAddInternationalCustomer && (
              <div className="flex justify-content-center align-items-center flex-1 cursor-pointer mb-3">
                <p
                  className=" text-lg font-medium capitalize ml-2 text-center"
                  style={{ color: "blue" }}
                  onClick={() => handleAddInternationalCustomer()}
                >
                  {!switchCustomerType
                    ? "Add International Customer"
                    : "Add National Customer"}{" "}
                  <i
                    className="pi pi-plus"
                    style={{
                      fontSize: "15px",
                      cursor: "pointer",
                      color: "blue",
                    }}
                  ></i>
                </p>
              </div>
            )}
          </div>
        )}
      ></Dialog>
      <div>
        <SuccessModal
          modalVisible={modalVisible}
          setModalVisible={setModalVisible}
          status={modalStatus}
          text={modalText}
        />
      </div>
    </div>
  );
}
